import { AfterViewInit, Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appShow]',
  standalone: false,
})
export class ShowDirective implements AfterViewInit {
  shown: boolean = false;
  input: any;
  icon: any;

  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    this.input = this.el.nativeElement.previousElementSibling;
    this.icon = this.el.nativeElement.firstElementChild.firstElementChild;
  }

  @HostListener('click') public onclick(): void {
    this.shown = !this.shown;
    this.renderer.setAttribute(this.input, 'type', this.shown ? 'text' : 'password');
    this.renderer.setAttribute(this.icon, 'class', this.shown ? 'fas fa-eye-slash' : 'fas fa-eye');
  }
}
